// import React, { useEffect, useState } from 'react';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getBalanceSheetTemp } from '@store/Finance/FinancialReports/FinancialReportsSlice';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardBody } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import Loading from '@components/Shared/Loader/Loading';

// const AuditBalance = () => {
//   const dispatch = useAppDispatch();
//   const { t, i18n } = useTranslation();
//   const [filter, setFilter] = useState({ startData: '', endData: '', accountlevel: '1' });
//   const { BalanceSheetTemp: data, loading, error } = useAppSelector(s => s.FinancialReports);

//   useEffect(() => {
//     dispatch(
//       getBalanceSheetTemp({
//         startDate: filter.startData,
//         endDate: filter.endData,
//         accountlevel: filter.accountlevel
//       })
//     );
//   }, []);

//   const handleDispatch = () => {
//     dispatch(
//       getBalanceSheetTemp({
//         startDate: filter.startData,
//         endDate: filter.endData,
//         accountlevel: filter.accountlevel
//       })
//     );
//   };

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: ':moduleHome'
//             },
//             {
//               name: 'ميزان المراجعة',
//               link: null
//             }
//           ]}
//           PageName='ميزان المراجعة'
//         />
//       </div>

//       <Card>
//         <CardBody>
//           <div className='row mb-2'>
//             <div className='col-lg-3'>
//               <div className='input-group flex-nowrap'>
//                 <span className='input-group-text fw-bold'>{t('من تاريـخ')}</span>
//                 <div className='input-group'>
//                   <input
//                     type='date'
//                     autoComplete='off'
//                     className='form-control'
//                     value={filter.startData}
//                     onChange={e => {
//                       setFilter({ ...filter, startData: e.target.value });
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className='col-lg-3'>
//               <div className='input-group flex-nowrap'>
//                 <span className='input-group-text fw-bold'>{t('إلى تاريـخ')}</span>
//                 <div className='input-group'>
//                   <input
//                     type='date'
//                     autoComplete='off'
//                     className='form-control'
//                     value={filter.endData}
//                     onChange={e => {
//                       setFilter({ ...filter, endData: e.target.value });
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className='col-lg-4'>
//               <div className='input-group flex-nowrap'>
//                 <span className='input-group-text fw-bold'>{t('مستوى الحساب')}</span>
//                 <select
//                   className='form-select'
//                   value={filter.accountlevel}
//                   onChange={e => {
//                     setFilter({ ...filter, accountlevel: e.target.value });
//                   }}
//                 >
//                   <option value='1'>1</option>
//                   <option value='2'>2</option>
//                   <option value='3'>3</option>
//                   <option value='4'>4</option>
//                   <option value='5'>5</option>
//                 </select>
//               </div>
//             </div>
//             <div className='col-lg-2'>
//               <button className='btn btn-theme w-100' onClick={handleDispatch}>
//                 {t('تحديث')}
//               </button>
//             </div>
//           </div>

//           <Loading loading={loading} error={error} Type='Dots'>
//             <table className='table text-nowrap table-hover '>
//               <thead className='bg-theme bg-opacity-30 '>
//                 <tr>
//                   <th>كود الحساب</th>
//                   <th>اسم الحساب</th>
//                   <th>الرصيد المدين</th>
//                   <th>الرصيد الدائن</th>
//                   <th>مستوى الحساب</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data?.list?.map(item => (
//                   <React.Fragment key={item.id}>
//                     <tr>
//                       <td>{item.accountNumber}</td>
//                       <td>{item.name2}</td>
//                       <td>{item.amounT_DR}</td>
//                       <td>{item.amounT_CR}</td>
//                       <td>{item.accountlevel}</td>
//                     </tr>
//                     {item.children &&
//                       item.children.map(child => (
//                         <tr key={child.id}>
//                           <td>{child.accountNumber}</td>
//                           <td>{child.name2}</td>
//                           <td>{child.amounT_DR}</td>
//                           <td>{child.amounT_CR}</td>
//                           <td>{child.accountlevel}</td>
//                         </tr>
//                       ))}
//                   </React.Fragment>
//                 ))}
//               </tbody>
//             </table>
//           </Loading>
//         </CardBody>
//       </Card>
//     </>
//   );
// };

// export default AuditBalance;

import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getBalanceSheetTemp } from '@store/Finance/FinancialReports/FinancialReportsSlice';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Loading from '@components/Shared/Loader/Loading';
import { Spinner, Alert } from 'react-bootstrap';

const AuditBalance = () => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const [filter, setFilter] = useState({ 
    startDate: '', 
    endDate: '', 
    accountlevel: '1' 
  });
  
  const { BalanceSheetTemp: data, loading, error } = useAppSelector(s => s.FinancialReports);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    dispatch(
      getBalanceSheetTemp({
        startDate: filter.startDate,
        endDate: filter.endDate,
        accountlevel: filter.accountlevel
      })
    );
  };

  const resetFilters = () => {
    setFilter({
      startDate: '',
      endDate: '',
      accountlevel: '1'
    });
  };

  const formatCurrency = (amount: number | null): string => {
    if (amount === null || amount === undefined) return '-';
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // حساب الإجماليات
  const calculateTotals = () => {
    if (!data?.list) return { totalDebit: 0, totalCredit: 0, totalBalance: 0 };

    const totalDebit = data.list.reduce((sum, item) => sum + (item.amounT_DR || 0), 0);
    const totalCredit = data.list.reduce((sum, item) => sum + (item.amounT_CR || 0), 0);
    const totalBalance = totalDebit - totalCredit;

    return { totalDebit, totalCredit, totalBalance };
  };

  const { totalDebit, totalCredit, totalBalance } = calculateTotals();

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'ميزان المراجعة',
              link: null
            }
          ]}
          PageName='ميزان المراجعة'
        />
      </div>

      <Card className='mb-4'>
        <div className='card-header d-flex justify-content-between align-items-center'>
          <h6 className='mb-0'>
            <i className='fas fa-balance-scale me-2'></i>
            ميزان المراجعة
            <span className='badge bg-primary ms-2'>التقرير المالي</span>
          </h6>
          <div>
            <span className='badge bg-theme me-2'>إجمالي الحسابات: {data?.list?.length || 0}</span>
            <span className={`badge ${totalBalance >= 0 ? 'bg-success' : 'bg-danger'}`}>
              الرصيد الإجمالي: {formatCurrency(Math.abs(totalBalance))}
            </span>
          </div>
        </div>

        <div className='card-body p-0'>
          {/* قسم الفلاتر */}
          <div className='p-3 border-bottom'>
            <div className='row mb-3'>
              <div className='col-lg-3 mb-2'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>من تاريـخ</span>
                  <input
                    type='date'
                    autoComplete='off'
                    className='form-control'
                    value={filter.startDate}
                    onChange={e => {
                      setFilter({ ...filter, startDate: e.target.value });
                    }}
                  />
                </div>
              </div>

              <div className='col-lg-3 mb-2'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>إلى تاريـخ</span>
                  <input
                    type='date'
                    autoComplete='off'
                    className='form-control'
                    value={filter.endDate}
                    onChange={e => {
                      setFilter({ ...filter, endDate: e.target.value });
                    }}
                  />
                </div>
              </div>

              <div className='col-lg-3 mb-2'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>مستوى الحساب</span>
                  <select
                    className='form-select'
                    value={filter.accountlevel}
                    onChange={e => {
                      setFilter({ ...filter, accountlevel: e.target.value });
                    }}
                  >
                    <option value='1'>المستوى 1</option>
                    <option value='2'>المستوى 2</option>
                    <option value='3'>المستوى 3</option>
                    <option value='4'>المستوى 4</option>
                    <option value='5'>المستوى 5</option>
                    <option value='6'>المستوى 6</option>
                  </select>
                </div>
              </div>

              <div className='col-lg-3 mb-2 d-flex gap-2'>
                <button className='btn btn-secondary flex-fill' onClick={resetFilters}>
                  إعادة تعيين
                </button>
                <button className='btn btn-theme flex-fill' onClick={fetchData} disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner
                        as='span'
                        animation='border'
                        size='sm'
                        role='status'
                        aria-hidden='true'
                        className='me-2'
                      />
                      جاري التحميل...
                    </>
                  ) : (
                    'تحميل التقرير'
                  )}
                </button>
              </div>
            </div>

            {error && (
              <Alert variant='danger' className='mt-3 mb-0'>
                خطأ في تحميل البيانات: {error}
              </Alert>
            )}
          </div>

          {/* قسم النتائج */}
          <Loading loading={loading} error={error} Type='Dots'>
            <div className='table-responsive'>
              <table className='table table-hover mb-0'>
                <thead className='table-actived fw-bold'>
                  <tr>
                    <th className='text-center small'>كود الحساب</th>
                    <th className='text-center small'>اسم الحساب</th>
                    <th className='text-center small'>الرصيد المدين</th>
                    <th className='text-center small'>الرصيد الدائن</th>
                    <th className='text-center small'>مستوى الحساب</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.list && data.list.length > 0 ? (
                    data.list.map((item, index) => (
                      <React.Fragment key={item.id || index}>
                        {/* الحساب الرئيسي */}
                        <tr className={item.accountlevel <= 2 ? 'table-warning fw-bold' : ''}>
                          <td className='text-center align-middle'>
                            <strong>{item.accountNumber}</strong>
                          </td>
                          <td className='align-middle'>
                            <strong>
                              {i18n.language === 'ar' ? item.name2 : item.name}
                            </strong>
                          </td>
                          <td className='text-center align-middle'>
                            <span className='badge bg-danger fs-6'>
                              {formatCurrency(item.amounT_DR)}
                            </span>
                          </td>
                          <td className='text-center align-middle'>
                            <span className='badge bg-success fs-6'>
                              {formatCurrency(item.amounT_CR)}
                            </span>
                          </td>
                          <td className='text-center align-middle'>
                            <span className='badge bg-secondary fs-6'>
                              {item.accountlevel}
                            </span>
                          </td>
                        </tr>
                        
                        {/* الحسابات الفرعية */}
                        {item.children && item.children.map((child, childIndex) => (
                          <tr key={child.id || `${index}-${childIndex}`} className='table-light'>
                            <td className='text-center align-middle ps-4'>
                              <small>{child.accountNumber}</small>
                            </td>
                            <td className='align-middle ps-4'>
                              <small>
                                {i18n.language === 'ar' ? child.name2 : child.name}
                              </small>
                            </td>
                            <td className='text-center align-middle'>
                              <small className='text-muted'>
                                {formatCurrency(child.amounT_DR)}
                              </small>
                            </td>
                            <td className='text-center align-middle'>
                              <small className='text-muted'>
                                {formatCurrency(child.amounT_CR)}
                              </small>
                            </td>
                            <td className='text-center align-middle'>
                              <small className='badge bg-light text-dark fs-6'>
                                {child.accountlevel}
                              </small>
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className='text-center py-4 text-muted'>
                        <i className='fa fa-inbox fa-2x mb-2'></i>
                        <br />
                        لا توجد سجلات للعرض
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Loading>
        </div>

        <div className='card-footer d-flex justify-content-between align-items-center'>
          <div className='text-muted small'>
            عرض {data?.list?.length || 0} من {data?.list?.length || 0} حساب
          </div>
          <div className='d-flex gap-3'>
            <span className='text-danger fw-bold'>إجمالي المدين: {formatCurrency(totalDebit)}</span>
            <span className='text-success fw-bold'>إجمالي الدائن: {formatCurrency(totalCredit)}</span>
            <span
              className={`fw-bold ${
                totalBalance > 0 ? 'text-danger' : totalBalance < 0 ? 'text-success' : 'text-muted'
              }`}
            >
              الرصيد النهائي: {formatCurrency(Math.abs(totalBalance))}
            </span>
          </div>
        </div>
      </Card>
    </>
  );
};

export default AuditBalance;